const useNewQuoteBlockDesign = (_isQuoteBlockRevamped?: boolean): boolean => {
	return true;
};
export default useNewQuoteBlockDesign;
